var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2AD2FF;}\n\t.st1{fill:#FFFFFF;fill-opacity:5.000000e-02;stroke:#00D9E9;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 150,
    cy: 150,
    r: 97
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.8,143.6c0.7-14-9.1-23.2-20.1-29.6l-7.2,42.1c3-0.4,6,0.5,8.3,2.5c2.7,2.6,2.9,6.8,0.5,9.7 C214.2,167.1,225,160.5,225.8,143.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.8,94.6l-8.5-8.6c12.9-1.6,46.8,0.4,79.6,21c0.3,1.8,0.3,3.7,0,5.5l2.8,1.4c4.5,7.4,5.7,16.3,3.6,24.6 c-2.8,11.4-7.7,16.4-9.9,17.5c-4.4,0-11.9,2.5-14.3,13.8c-2.4,11.3-7.1,13.7-9.1,13.5l-48.5,0.6l-32-18.9l-4.6-39l9.1-12.1 l16.2-13.3l11.6-4.7L131.8,94.6z M189.1,110.6c-1.4,1.5-3,2.7-4.7,3.6c-12.5-2.7-17-9.1-17-9.1c10.6-0.3,21.1,2.3,30.3,7.5 C194.9,111.7,192,111,189.1,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.6,169.9c-9.2,4.4-19.3,6.7-29.6,6.6c-30.6,0-55.3-19.2-55.3-42.9c0-17.5,13.5-32.6,32.9-39.2 c-36.9,2.1-66.5,31.7-66.5,68.3c0,42.2,37.6,77,83.9,77c32.8-0.3,62.8-18.2,78.6-46.9C207.9,197.5,183.3,188.6,184.6,169.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnt);
export default __webpack_public_path__ + "static/media/ANT.9b64ec4a033eac8a0c888f84a41e941d.svg";
export { ForwardRef as ReactComponent };